import { CSSProperties, FC, memo } from "react";
import "./MisceleniousStyles.css";

interface ITaskTagProps {
    color: string;
    name: string;
    style?: CSSProperties;
    className?: string;
}

const TaskTag: FC<ITaskTagProps> = memo(({ 
    color, 
    name, 
    style, 
    className 
}) => {
    return (
        <div
            className={`task-teg-widget nonselectable ${className || ''}`}
            style={{
                backgroundColor: color,
                ...style,
            }}
        >
            <a
                className="task-type-text"
                style={{ color: "rgba(0, 0, 0, 0.7)" }}
            >
                {name}
            </a>
        </div>
    );
});

TaskTag.displayName = 'TaskTag';

export default TaskTag;